import { CheckFilled, Close } from "Components/Icons";
import React, { useState } from "react";
import classes from "./styles.module.scss";
import { Button } from "Components/ReactstrapSlim";
import { isClaimOptionVisible } from "../isClaimOptionVisible";

interface BannerProps {
   isClaimable: LSCommon.Service.LSWebUI.Models.XPP.Claimable;
   onClaim: () => void;
}

export const Banner: React.FC<BannerProps> = ({ isClaimable, onClaim }) => {
   const [isVisible, setVisible] = useState(isClaimOptionVisible(isClaimable));

   return isVisible
      ? <div className={classes.container}>
         <div className={classes.i1}>
            <span>
               <CheckFilled width={24} height={24} className={classes.icon} />
               <span className="h7">Claim this profile, if it belongs to you. </span>
            </span>
            <span className="p1">Currently, space isn't available for booking at LiquidSpace.</span>
         </div>
         <div className={classes.buttons}>
            <Button color="link" className={classes.cta} onClick={onClaim}>Claim Profile</Button>
            <Button color="icon" className={classes.close} onClick={() => setVisible(false)}><Close /></Button>
         </div>
      </div>
      : null
}

export default Banner;

